export default class SupportChat {
  static init = (current_user_logged_in) => {
    if(current_user_logged_in) {
      Intercom('show');
    } else {
      window.location.href = '/login';
    }
  }
}